/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{margin:auto}.form-group[_ngcontent-%COMP%]{display:flex;justify-content:center;margin-bottom:0}.form-control[_ngcontent-%COMP%]{width:45px!important;padding-left:1rem!important;text-align:center}.form-control[_ngcontent-%COMP%]:not(:last-child){margin-right:.5rem}"];
export { styles as styles };
